import { RequiredProvisionModalProps } from './types';
import {
  useProvisionModalFields,
  UseProvisionModalFieldsProps,
} from './hooks/useProvisionModalFields';
import { BaseProvisionModal } from './BaseProvisionModal';
import { INTEGRATION_SERVICE_NAMES } from '@constants/integration';
import { PasswordField } from './Fields/PasswordField';
import { DataBaseNameField } from './Fields/DatabaseNameField';
import { AdvancedFields } from './Fields/AdvancedFields';
import { ProvisionModalResponseSection } from './Fields/ProvisionModalResponseSection';
import { ProvisionSection } from './Fields/ProvisionSection';
import { UsernameField } from './Fields/UsernameField';
import { FieldsContainer, ModalBodyFieldContainer } from './styles';

const targetService = INTEGRATION_SERVICE_NAMES.DELTEK_AJERA_HOSTED;

const formatProvisionPayload: UseProvisionModalFieldsProps['formatProvisionPayload'] = ({
  inputValues,
}) => {
  const paramsOnAgent = {
    serviceName: targetService,
    credentials: {
      username: inputValues.username,
      password: inputValues.password,
      database: inputValues.databaseName,
    },
    settings: {
      ConsultFee: false,
    },
  };

  return {
    serverUrl: inputValues.serverAddress,
    paramsOnAgent,
    paramsOnGalaxy: {
      s3BucketName: inputValues.bucketName,
      realmId: inputValues.realmId,
    },
  };
};

export const DeltekAjeraProvisionModal: React.FC<RequiredProvisionModalProps> = ({
  teamId,
  toggle,
}) => {
  const {
    inputValues,
    handleInputChangeV2,
    togglePasswordVisibility,
    isProvisioningIntegration,
    handleToggleAdvanced,
    showAdvancedSetting,
    resetServerAddress,
    handleCheckboxChange,
    provisionIntegrationError,
    provisionIntegrationData,
    handleForceProvision,
    handleProvision,
  } = useProvisionModalFields({
    teamId,
    targetService,
    formatProvisionPayload,
  });

  const ModalBody = (
    <ModalBodyFieldContainer>
      <FieldsContainer>
        <DataBaseNameField onChange={handleInputChangeV2} databaseName={inputValues.databaseName} />
        <PasswordField
          onChange={handleInputChangeV2}
          onClickVisibilityIcon={togglePasswordVisibility}
          showPassword={inputValues.showPassword}
          password={inputValues.password}
        />
        <UsernameField onChange={handleInputChangeV2} username={inputValues.username} />
      </FieldsContainer>

      {showAdvancedSetting ? (
        <AdvancedFields
          onClickUndo={resetServerAddress}
          bakIntegration={inputValues.bakIntegration}
          bucketName={inputValues.bucketName}
          serverAddress={inputValues.serverAddress}
          realmId={inputValues.realmId}
          handleCheckboxChange={handleCheckboxChange}
          onChange={handleInputChangeV2}
        />
      ) : null}

      <ProvisionSection
        onProvisionClick={handleProvision}
        onForceProvision={handleForceProvision}
        disableProvisionButton={isProvisioningIntegration}
        isLoading={isProvisioningIntegration}
        handleToggleAdvanced={handleToggleAdvanced}
        showAdvancedSetting={showAdvancedSetting}
      />

      <ProvisionModalResponseSection
        isLoading={isProvisioningIntegration}
        error={provisionIntegrationError}
        responseData={provisionIntegrationData}
        teamId={teamId}
        targetService={targetService}
      />
    </ModalBodyFieldContainer>
  );

  return (
    <BaseProvisionModal
      toggle={toggle}
      targetService={targetService}
      teamId={teamId}
      body={ModalBody}
      isRequesting={isProvisioningIntegration}
    />
  );
};
